import Scene = Phaser.Scene;
import Graphics = Phaser.GameObjects.Graphics;
import Container = Phaser.GameObjects.Container;

export class ListBlackouter {

    private blackoutImage!: Graphics;

    private faded: boolean = false;
    private showCallback: ((children: Container[], titleText: string) => unknown) | undefined;
    private initCallback: (() => unknown) | undefined;

    private scene: Scene | undefined;

    public blackout(scene: Scene, canvas: HTMLCanvasElement, showCallback: (children: Container[], titleText: string) => unknown) {
        this.scene = scene;
        this.showCallback = showCallback

        scene.tweens.killTweensOf(this.blackoutImage);

        let self = this;

        self.blackoutImage = scene!.add.graphics();
        self.blackoutImage.setDepth(10000).setAlpha(0);

        let color = Phaser.Display.Color.HexStringToColor('#000000').color;

        self.blackoutImage.fillRect(0, 0, canvas.width, canvas.height);
        self.blackoutImage.fillStyle(color);

        scene.tweens.add({
            targets: self.blackoutImage,
            alpha: 1,
            duration: 300,
            onStop() {
                self.blackoutImage.destroy();
            },
            onComplete() {
                self.blackoutImage.setAlpha(1);
                self.faded = true;
                if (self.initCallback) {
                    self.initCallback();
                }
            }
        });
    }

    public notifyLoaded(initCallback: () => unknown) {
        this.initCallback = initCallback;
        if (this.faded) {
            initCallback();
        }
    }

    public notifyInitialized(children: Container[], titleText: string) {
        let self = this;
        self.showCallback!(children, titleText);
        self.scene!.tweens.add({
            targets: self.blackoutImage,
            alpha: 0,
            duration: 300,
            onStop() {
                self.blackoutImage.destroy();
            },
            onComplete() {
                self.blackoutImage.destroy();
                // self.scene = undefined;
                // self.showCallback = undefined;
            }
        });
    }

    public notifyReinitialized(children: Container[], titleText: string) {
        this.showCallback!(children, titleText);
    }
}
